/* eslint-disable react/react-in-jsx-scope */
import cx from "clsx";
import { BaseComponentProps, WithChildrenProps } from "../../BaseComponentProps";

interface HeadButtonProps extends BaseComponentProps, WithChildrenProps {
  href?: string | undefined;
}

/**
 * Reusable component that renders a button
 * @param props
 */

export default function HeadButton(props: HeadButtonProps): JSX.Element {
  const { className, children, href } = props;

  const classes = cx(
    className,
    "tab btn no-border-color new-border-radius text-white mr-3 font-medium transition-all duration-200 hover:opacity-90 hover:scale-[1.02] active:scale-[0.98]",
  );

  return (
    <a className={classes} href={href}>
      {children}
    </a>
  );
}
